<script>
    export let loading = false;
    export let disabled = false;
</script>

<button on:click|preventDefault disabled={disabled || loading}>
	<span></span>
</button>

<style>

	button {
		height: 50px;
		position: relative;
		background-color: var(--color-charcoal);
        border: 3px solid var(--color-charcoal);
/*		outline: 0 !important;
		outline-offset: 0;
*/		width: 2.5rem;
        padding-top: 10px;
        padding-left: 15px;
        padding-right: 30px;
		border-radius: var(--border-radius-sm);
	}

 	button span::after {
		position: absolute;
		border-color: #ff4814;
		border-style: solid;
		border-width: 3px 3px 0 0;
		content: "";
		height: 12px;
		width: 12px;
		top: 16px;
		left: 20px;
		transform: rotate(225deg);
		transition: left 0.35s;
	}

	button:hover span::after {
		left: 17px;
	}
	
    button:disabled {
		pointer-events: none;
		opacity: .3;
    }

</style>
